export const AddressColumns = [
    "Destination",
    'Deliveryaddresscode', 
    'Deliveryaddress',
    'Buyeraddresscode', 
    'Buyeraddress',
    "Buyername",
    'Shiptoaddress',
    'ShipMode',

  
]